import { createAsyncThunk } from "@reduxjs/toolkit";
import axiosInstance from "../../axiosInstance.js";

export const fetchTeacherSubscription = createAsyncThunk(
  "teacherSubscription/fetch",
  async (_, thunkAPI) => {
    try {
      const { data } = await axiosInstance.get(`/subscriptions/teacher`);
      // console.log(data);

      return data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.response?.data || "Error");
    }
  }
);

export const updateTeacherSubscriptionStatus = createAsyncThunk(
  "teacherSubscription/updateStatus",
  async (newStatus, thunkAPI) => {
    try {
      const { data } = await axiosInstance.patch(
        "/subscriptions/update-status",
        { newStatus }
      );
      // console.log(data);

      return data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.response?.data || "Error");
    }
  }
);
